import { Dispatch, SetStateAction, createContext } from "react";

type KimlikBilgisi = {
  IIN: string;
};

export type User = {
  doctorId?: string;
  serviceId?: string;
  date?: string;
  selectedDateTime?: string;
  fullName?: string;
  phone?: string;
  token?: string;
  kimlikBilgisi?: KimlikBilgisi;
  doctorName?: string;
  doctorType?: string;
  doctorPrice?: number;
  firstName?: string;
  lastName?: string;
};

export type UserContextType = {
  user: User | null;
  setUser: Dispatch<SetStateAction<User | null>>;
};

export const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => {},
});
